import { render, staticRenderFns } from "./RescuePage.vue?vue&type=template&id=20c752b8&scoped=true&"
import script from "./RescuePage.vue?vue&type=script&lang=js&"
export * from "./RescuePage.vue?vue&type=script&lang=js&"
import style0 from "./RescuePage.vue?vue&type=style&index=0&id=20c752b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c752b8",
  null
  
)

export default component.exports